<template>
  <div class="home">
    <div class="container">
      <customer-service :position="35" />
      <!-- 审核结果 -->
      <div class="audit">
        <div class="audit-result">
          <span class="audit-result-question">审核结果：</span>
          <span class="audit-result-answer">{{ censorStatusDescription }}</span>
        </div>

        <div class="audit-explain" v-if="censorResult.censorStatus === '1'">
          将在3-5个工作日内完成审核，请留意短信通知
        </div>
        <div class="audit-explain" v-if="censorResult.censorStatus === '3'">
          未通过原因：{{ censorResult.censorMessage }}
        </div>
        <!-- <div class="audit-explain" v-if="censorResult.censorStatus == '2'">点击下方按钮即可享受0元购课福利！</div> -->

        <div class="list">
          <div class="list-item">
            <label>手机号码</label>
            <span>{{ censorResult.mobile }}</span>
          </div>
          <div class="list-item">
            <label>姓名</label>
            <span>{{ censorResult.name }}</span>
          </div>
          <div class="list-item">
            <label>身份证号</label>
            <span>{{ censorResult.card }}</span>
          </div>
          <div class="list-item">
            <label>教师资格证号</label>
            <span>{{ censorResult.teacherCard }}</span>
          </div>
        </div>
      </div>
      <!-- 学而思公众号介绍 -->
      <!-- <div class="qrcodeText">关注“学而思网校”公众号，获得更多教育资讯与专业服务。</div> -->
      <!-- 学而思网校公众号 -->
      <!--      <official-account :qrcodeSrc="wxQrcode" v-if="censorResult.censorStatus === '1'"/>-->

      <!-- 审核通过- 学习卡提示 -->
      <div v-if="censorResult.applyType !== '1' && censorResult.censorStatus === '2'" class="card">
        <img src="../assets/images/teacher@2x.png" alt="" />
      </div>

      <!-- foot -->
      <div
        :class="{
          footer: censorResult.censorStatus !== '1',
          'btn-box': censorResult.censorStatus === '1'
        }"
      >
        <!-- <div class="backhome" @click="handleGoHome"><span>返回活动首页</span></div> -->

        <div
          class="vite-btn"
          style="margin-top: 18px;"
          @click="handleVerify"
          v-if="censorResult.censorStatus === '3'"
        >
          修改申领信息
        </div>

        <div
          v-if="censorResult.censorStatus === '2' && censorResult.applyType === '1'"
          class="buy-tip"
        >
          为避免课程领完下架请在24小时内完成选课
        </div>
        <div
          class="vite-btn"
          @click="handleBuy"
          v-if="censorResult.censorStatus === '2' && censorResult.applyType === '1'"
        >
          立即选课
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
// import officialAccount from '../components/officialAccount'
import customerService from '../components/customerService'

export default {
  name: 'home',
  components: {
    // 'official-account': officialAccount,
    'customer-service': customerService
  },
  data() {
    return {
      censorResult: {
        card: '', // 身份证号
        censorMessage: '', // 审核不通过的原因
        censorStatus: '3', // 审核状态 1:审核中 2:审核通过 3:审核不通过
        name: '', // 用户姓名
        mobile: '', // 手机号
        teacherCard: '', // 教师资格证号
        applyType: '', // 当前申领的类型,0 为素养课，1 为正价课，
        couponStatus: '', // 领劵状态， 0 未领取  1 已领取
        couponEndTime: '' // 是否已过领劵时间
      }, // 审核所需参数
      censorStatusDescription: '',
      wxQrcode: '', // 获取公众二维码地址
      activityStatus: '', // 活动状态 1 进行中  0 已结束，已结束不展示倒计时
      applyEndTime: '', // 活动结束时间
      origin: '0'
    }
  },
  async created() {
    this.init()
    this.$xesLogger.clickMsg({
      params: {
        pageuid: 'activitiesPage5',
        clickid: 1,
        action: 'result_view_uv',
        clickname: '点击进入',
        origin: this.origin
      }
    })
  },
  watch: {
    censorResult: {
      handler(val) {
        const censorStatus = val.censorStatus
        if (censorStatus === '1') {
          this.censorStatusDescription = '审核中'
        } else if (censorStatus === '2') {
          this.censorStatusDescription = '审核通过'
        } else if (censorStatus === '3') {
          this.censorStatusDescription = '审核未通过'
        }
      },
      deep: true
    }
  },
  methods: {
    // 获取审核结果
    async getCensorResult() {
      const res = await this.$api.censorResult()

      // 测试代码
      // res.code = 0
      // res.data.name = "111";
      // res.data.censorStatus = '2'
      // res.data.applyType !== '1'

      if (res.code === 0) {
        const censorResult = res.data || {}
        this.censorResult = censorResult
      } else {
        Dialog.alert({
          title: '提示',
          message: res.msg || '未查询到您的审核信息'
        }).then(() => {
          this.handleGoHome()
        })
      }
    },
    // 回到首页
    handleGoHome() {
      this.$router.push({
        name: 'home'
      })
    },
    // 修改申请信息
    async handleVerify() {
      if (this.censorResult && this.censorResult.activityStatus === '1') {
        this.$router.push({
          name: 'uploadProof'
        })
      } else {
        Dialog.alert({
          title: '活动已结束',
          message: '活动已结束，如需修改信息请联系客服'
        })
      }
    },
    // 立刻购买
    handleBuy() {
      let endTime = this.censorResult.couponEndTime
      endTime = endTime ? endTime.replace(/-/g, '/') : ''
      if (new Date(endTime).getTime() < Date.now()) {
        Dialog.alert({
          title: '活动已结束',
          message: '非常抱歉，本次活动已结束，请关注下次活动，如有疑问请点击客服咨询'
        })

        return
      }

      this.$xesLogger.clickMsg({
        params: {
          pageuid: 'activitiesPage5',
          clickid: 1,
          action: 'click_buy1_pv',
          clickname: '点击购买',
          origin: this.origin
        }
      })

      if (this.censorResult.couponStatus === '1') {
        // 已申领
        this.$router.push({
          name: 'payPage'
        })
      } else {
        this.$router.push({
          name: 'getCoupons'
        })
      }
    },
    async init() {
      const res = await this.$api.activityPage({ isShow: 1 })
      if (res.code === 0) {
        const data = res.data || {}
        this.wxQrcode = data.wxQrcode
        this.activityStatus = data.activityStatus
        this.applyEndTime = data.applyEndTime

        // data.activityStatus = 0;
        // data.applyEndTime = '2020-08-20';
        this.getCensorResult()
      } else {
        Dialog.alert({
          title: '提示',
          message: res.message
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  min-height: 100vh;

  &-btn {
    height: 44px;
    margin: 280px 30px 0;
    font-size: 24px;
    line-height: 44px;
    text-align: center;
    color: #fff;
    background-color: #ed3b31;
    border-radius: 22px;
  }

  /deep/ .xes-login {
    width: 100vw;

    .xes-login-logo {
      display: none;
    }

    .xes-login-title i {
      display: none;
    }

    .xes-login-cell .xes-login-input {
      flex: 1;
    }

    .xes-login-cell .xes-login-btn {
      margin-left: 6px;
    }
  }

  // .customer-service {
  //   position: fixed;
  //   top: 0;
  //   right: 0;
  //   z-index: 100;
  //   width: 53px;
  //   height: 26px;
  // }
  .container .card {
    margin: 0 32px;
    font-size: 0;

    .out-line {
      padding: 6px;
      background: #e52c30;
      border-radius: 8px;

      .in-line {
        padding: 24px 16px;
        border: 1px solid #eb7261;
        border-radius: 8px;

        .title {
          margin-bottom: 24px;
          font-size: 16px;
          text-align: center;
          color: #fff;
        }

        .cont {
          font-size: 12px;
          color: #fef0dc;
        }
      }
    }
  }

  .audit {
    padding: 36px 24px 30px 24px;
    // margin-top: 64px;
    margin-bottom: 15px;
    background-color: #fef0dc;

    &-result {
      margin-bottom: 12px;

      &-question {
        font-size: 18px;
        font-weight: 500;
        line-height: 22px;
        text-align: left;
        color: #b28f54;
      }

      &-answer {
        font-size: 18px;
        font-weight: 500;
        line-height: 22px;
        text-align: left;
        color: #333;
      }
    }

    &-explain {
      margin-bottom: 8px;
      font-size: 13px;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
      color: #666;
    }

    .list {
      padding-top: 18px;
      border-top: 1px solid rgba(183, 181, 184, 0.5);

      .list-item {
        display: flex;
        margin-bottom: 4px;

        &:last-child {
          margin-bottom: 0;
        }

        > label {
          width: 110px;
          margin-right: 12px;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          text-align: left;
          color: #999;
        }

        > span {
          flex: 1;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          text-align: left;
          color: #666;
        }
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 12px 32px;
  }

  .footer .btn-download {
    width: 100%;
    height: 40px;
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    color: #ef8083;
    background: #fef9f2;
    border-radius: 20px;
  }

  .backhome {
    margin-bottom: 18px;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
    text-align: center;
    color: #666;

    > span {
      border-bottom: 1px solid #333;
    }
  }

  .buy-tip {
    margin-bottom: 4px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #f59a23;
    font-style: normal;
  }

  .btn-box {
    margin: 0 32px 20px;
  }

  .vite-btn {
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background-color: #00aced;
    border-radius: 20px;
  }

  .vite-btn-last {
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #ed3b31;
    background-color: #fef9f2;
    border: 1px solid #ef8083;
    border-radius: 20px;
  }

  .prompt {
    font-size: 10px;
    font-weight: 500;
    line-height: 49px;
    text-align: left;
    text-align: center;
    color: #666;
  }

  .approved {
    margin: 0 29px;

    &-text {
      width: 323px;
      height: 31px;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: left;
      color: #999;
    }
  }

  .qrcodeText {
    font-size: 14px;
  }
}
</style>
